import axios from 'axios'

const broker_register_form = {
  namespaced: true,
  state() {
    return {
      data: {
        email: null,
        uuid: null,
        password: null,
        name: null,
        name_kana: null,
        contact: null,
        office: null,
        department: null,
        use_two_step_authentication: false,
        company: {
          name: null,
          name_kana: null,
          licence_type: null,
          licence_number: null,
          postal_code: null,
          prefecture_code: null,
          address1: null,
          address2: null,
          tel: null,
          fax: null,
        },
      },
      errors: {},
      isLoadErrorConflict: false,
      isLoadErrorGone: false,
    }
  },

  getters: {
    parameters(state) {
      return {
        uuid: state.data.uuid,
        name: state.data.name,
        name_kana: state.data.name_kana,
        contact: state.data.contact,
        office: state.data.office,
        department: state.data.department,
        password: state.data.password,
        use_two_step_authentication: state.data.use_two_step_authentication
      };
    },
  },

  mutations: {
    setData(state, data) {
      state.data.email = data.email;
      state.data.company = data.company
      state.errors = {};
    },
    setUuid(state, uuid) {
      state.data.uuid = uuid
    },
    setLoadError(state, payload) {
      state.isLoadErrorConflict = (payload.status === 409);
      state.isLoadErrorGone = (payload.status === 410);
    },
    setErrors(state, errors) {
      state.errors = {...errors}
    },
    resetData(state) {
      state.data.email = null
    },
    clearError(state) {
      state.errors = {}
    },
    inputFormItem(state, payload) {
      if (state.data[payload.column] !== undefined) {
        state.data[payload.column] = payload.value;
      }
    },
  },

  actions: {
    load({commit}, {uuid}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/brokers/provisional', {params: {'uuid': uuid}}).then((response) => {
          commit('setData', response.data.data)
          commit('setUuid', uuid)
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if ([409, 410].includes(error.response.status)) {
            commit('setLoadError', {status: error.response.status});
            handled = true;
          }
          reject({handled});
        });
      });
    },

    register({getters, commit}) {
      commit('clearError')
      return new Promise((resolve, reject) => {
        axios.post('/api/brokers', getters.parameters).then(() => {
          commit('setFlashMessage', {value: '登録しました'}, {root: true});
          commit('resetData')
          commit('clearError')
          resolve(true)
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({handled});
        });
      });
    }
  }
}

export default broker_register_form;
